import { render } from "./release.vue?vue&type=template&id=4069a8e3&scoped=true"
import script from "./release.vue?vue&type=script&lang=js"
export * from "./release.vue?vue&type=script&lang=js"

import "./release.vue?vue&type=style&index=0&id=4069a8e3&lang=scss&scoped=true"
import "./release.vue?vue&type=style&index=1&id=4069a8e3&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4069a8e3"]])

export default __exports__